import React from "react"

import { ChildSelector } from "../helpers/ChildSelector"

import CubewiseLink from "./_base/CubewiseLink"
import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

import * as heroCardStyles from "../styles/HeroCard.module.css"

export default function HeroCard(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `hero-card-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const text = ChildSelector.select(
    content,
    `hero-card-content`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const linkParentNode = ChildSelector.select(
    content,
    `hero-card-content`,
    ChildSelector.SELECTOR_TYPE.NODE
  )
  let link = null
  if (linkParentNode) {
    const linkNode = linkParentNode.childNodes[0]
    if (linkNode && linkNode.attributes && linkNode.attributes.href)
      link = linkNode.attributes.href
  }

  return (
    <div
      className={`row hero-card-wrapper ${heroCardStyles.wrapper} ${props.className}`}
    >
      <CubewiseLink
        linkPath={link}
        translate={props.translate}
        pageContext={props.pageContext}
        modals={props.modals}
      >
        <div className={`col-1 ${heroCardStyles.logo}`}>
          <WPImage
            holder={content}
            selector={`hero-card-icon`}
            mode={DISPLAY_MODE.inline}
          />
        </div>
        <div className={`col-10 ${heroCardStyles.holder}`}>
          <h4 className={`${heroCardStyles.title}`}>{title}</h4>
          <hr />
          <p className={`${heroCardStyles.content}`}>{text}</p>
        </div>
      </CubewiseLink>
    </div>
  )
}
